import styled from "styled-components";
import AdminMenu from "../../../components/admin/menu";
import AdminPageContainer from "../../../components/admin/page-container";
import MultiCodeAddForm from "./multi-add-form";

const Container = styled.div`
    font-size: 16px;
`;

export default function AddLibraryPage() {

    // const { mutate } = useMutation(Network.addLibrary);

    // const [code, setCode] = useState<string>();

    // const createLibrary = useCallback(() => {

    //     const code = randomCode();

    //     setCode(code);

    //     mutate({ code });
    // }, [mutate, setCode]);



    return <Container>
        <AdminPageContainer>
            <AdminMenu />
            <h2>Dodaj nowe biblioteki</h2>
            <div className="add-existing">
                <h3>Dodaj kody bibliotek do bazy danych</h3>
                <p>Ten formularz pozwala na dodanie do bazy danych kodów bibliotek</p>
                <MultiCodeAddForm />
            </div>
            {/* <div className="generate">
                <p>xxxxxxxxxxxxx</p>
            </div>
            <div className="post-page-box-links">
                <NextButton onClick={createLibrary}>Dodaj nową bibliotekę</NextButton>
            </div>
            <div>
                Kod twojej biblioteki: <strong>{code}</strong>
            </div>
            <div>
                Link dla członków twojej biblioteki: <strong>{window.location.protocol}//{window.location.host}{process.env.PUBLIC_URL}/l/{code}</strong>
            </div>
            <div>
                Link do edycji biblioteki: <Link to={getEditLibraryRoute(code)}>{window.location.protocol}//{window.location.host}{process.env.PUBLIC_URL}{getEditLibraryRoute(code)}</Link>
            </div> */}
        </AdminPageContainer >
    </Container >
}


// function randomCode() {
//     const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', '1', '2', '3', '4', '5', '6'];

//     let result = '';

//     for (let i = 0; i < 8; i++) {
//         result += letters[Math.floor(Math.random() * letters.length)];
//     }

//     return result;
// }
